function generateBranchName(value) {
  const randomNumber = Math.floor(Math.random() * 1e4);
  const branchName = `${value.toLowerCase().trim().replace(/ /g, "-").replace(".", "-")}-patch${randomNumber}`;
  return branchName;
}

export { generateBranchName };
//# sourceMappingURL=generateBranchName.esm.js.map
